export default "__VITE_ASSET__sD8iWfMD__"